import script from "./Page12.vue?vue&type=script&setup=true&lang=js"
export * from "./Page12.vue?vue&type=script&setup=true&lang=js"

import "./Page12.vue?vue&type=style&index=0&id=ddbef124&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddbef124"]])

export default __exports__